import styled from 'styled-components';
import { Card as CardAntd } from 'antd';

const { Meta } = CardAntd;

export const Card = styled(CardAntd)`
    width: 400px;
    height: 400px;
    margin-left: auto;
    margin-right: auto;

    @media screen and (max-width: 1500px) {
        width: 240px;
        height: 350px;
    }

    @media screen and (max-width: 768px) {
        width: 260px;
        height: 340px;
    }
`

export const MetaCard = styled(Meta)`

`